export default __webpack_public_path__ + "static/media/2103.ff3ffe13.svg";